import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { Observable, map } from 'rxjs';

export interface AllGroups {
	permission?: string;
	distinguishedName?: string;
	usertype?: string;
	description?: string;
	customer?: number;
	full_name?: string;
	email?: string;
	sort_order?: number;
}

@Injectable({
	providedIn: 'root',
})
export class GroupsUsersService {
	private getAllEndusersGroupsURL = environment.baseApiUrl + 'enduser/groups/{group_name}';
	private getSearchPermissionsURL = environment.baseApiUrl + 'enduser/searchPermissions';
	private getSearchUsertypeURL = environment.baseApiUrl + 'enduser/searchUsertype';
	private getSearchGroupAdURL = environment.baseApiUrl + 'enduser/searchGroupAd';
	private getPermissionSortOrderURL = environment.baseApiUrl + 'enduser/permissionSortOrder';
	private updatePermissionAnalystURL = environment.baseApiUrl + 'enduser/updatePermissionAnalyst/{distinguishedName}';
	private updateSortOrderURL = environment.baseApiUrl + 'enduser/updateSortOrder';

	constructor(
		private httpClient: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getAllEndusersGroups(groupNameEndusers: string): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const getAllEndusersGroupsURL = this.getAllEndusersGroupsURL.replace('{group_name}', groupNameEndusers);
		return this.httpClient.get<JSON[]>(getAllEndusersGroupsURL, { headers: headers }).pipe(
			map((enduser) => {
				const body: AllGroups[] = [];
				enduser.forEach((infoEnduser: any) => {
					const infoEndusers: AllGroups = {
						full_name: infoEnduser.full_name,
						email: infoEnduser.email,
					};

					body.push(infoEndusers);
				});

				return body;
			})
		);
	}

	getSearchPermissions(): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.httpClient.get<any[]>(this.getSearchPermissionsURL, { headers: headers }).pipe(
			map((group) => {
				const body: AllGroups[] = [];
				group.forEach((infoGroup: any) => {
					const infoGroups: AllGroups = {
						permission: infoGroup.permission,
						description: infoGroup.description,
					};

					body.push(infoGroups);
				});

				return body;
			})
		);
	}

	getGroupSortOrder(): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.httpClient.get<any[]>(this.getPermissionSortOrderURL, { headers: headers }).pipe(
			map((group) => {
				const body: AllGroups[] = [];
				group.forEach((infoGroup: any) => {
					const infoGroups: AllGroups = {
						sort_order: infoGroup.sort_order,
						distinguishedName: infoGroup.distinguishedName,
						usertype: infoGroup.usertype,
					};

					body.push(infoGroups);
				});

				return body;
			})
		);
	}

	getSearchUsertype(): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.httpClient.get<any[]>(this.getSearchUsertypeURL, { headers: headers }).pipe(
			map((group) => {
				const body: AllGroups[] = [];
				group.forEach((infoGroup: any) => {
					const infoGroups: AllGroups = {
						customer: infoGroup.customer,
						usertype: infoGroup.usertype,
						sort_order: infoGroup.sort_order,
					};

					body.push(infoGroups);
				});

				return body;
			})
		);
	}

	getSearchGroupAd(): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.httpClient.get<any[]>(this.getSearchGroupAdURL, { headers: headers }).pipe(
			map((group) => {
				const body: AllGroups[] = [];
				group.forEach((infoGroup: any) => {
					const infoGroups: AllGroups = {
						customer: infoGroup.customer,
						distinguishedName: infoGroup.distinguishedName,
						usertype: infoGroup.usertype,
					};

					body.push(infoGroups);
				});

				return body;
			})
		);
	}

	saveGroupAndPermission(groupValue: string, permissionValue?: string): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const updatePermissionAnalystURL = this.updatePermissionAnalystURL.replace('{distinguishedName}', groupValue);
		const body = {
			usertype: permissionValue,
			distinguishedName: groupValue,
		};

		return this.httpClient.put(updatePermissionAnalystURL, body, { headers: headers });
	}

	updateSortOrder(payload: any[]): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const body = payload;
		return this.httpClient.put<any[]>(this.updateSortOrderURL, body, { headers: headers });
	}
}
